import React, { useEffect, useState } from 'react';
import { api, getStoredUser, setSession } from '../api';

export default function AdminSettings() {
  const user = getStoredUser();
  const [coupleNames, setCoupleNames] = useState('');
  const [weddingDate, setWeddingDate] = useState('');
  const [savedMsg, setSavedMsg] = useState('');
  const [pwCurrent, setPwCurrent] = useState('');
  const [pwNew, setPwNew] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [pwError, setPwError] = useState('');
  const [link, setLink] = useState('');

  useEffect(() => {
    api.me().then((me) => {
      setCoupleNames(me.couple_names || '');
      setWeddingDate(me.wedding_date || '');
    });
    api.qrLink().then((r) => setLink(r.url)).catch(() => {});
  }, []);

  async function saveInfo(e) {
    e.preventDefault();
    setSavedMsg('');
    await api.updateMe({ couple_names: coupleNames, wedding_date: weddingDate });
    const token = localStorage.getItem('wsa_token');
    setSession(token, { ...user, full_name: user.full_name });
    setSavedMsg('U ruajt me sukses.');
  }

  async function changePassword(e) {
    e.preventDefault();
    setPwError('');
    setPwMsg('');
    try {
      await api.changePassword({ current_password: pwCurrent, new_password: pwNew });
      setPwMsg('Fjalëkalimi u ndryshua.');
      setPwCurrent('');
      setPwNew('');
    } catch (err) {
      setPwError(err.message);
    }
  }

  function copyLink() {
    navigator.clipboard.writeText(link);
    setSavedMsg('Linku u kopjua.');
  }

  return (
    <div className="settings-page">
      <h2>Cilësimet e Eventit</h2>

      <div className="settings-card">
        <h3>Linku dhe QR Kodi juaj</h3>
        <p className="page-hint">Ky është linku unik i dasmës suaj — printojeni QR kodin dhe vendoseni në hyrje të sallës.</p>
        <div className="qr-preview">
          <img src={api.qrUrl()} alt="QR kod" width={160} height={160} />
          <div>
            <code className="link-box">{link}</code>
            <div className="settings-actions">
              <button onClick={copyLink}>Kopjo Linkun</button>
              <a href={api.qrUrl()} download="qr-kodi.png"><button>Shkarko QR</button></a>
              <a href={api.pdfUrl()} target="_blank" rel="noreferrer"><button>Shkarko PDF</button></a>
            </div>
          </div>
        </div>
      </div>

      <form className="settings-card" onSubmit={saveInfo}>
        <h3>Emrat e Çiftit &amp; Data</h3>
        <label>
          Emrat e çiftit (shfaqet te faqja e mysafirëve)
          <input value={coupleNames} onChange={(e) => setCoupleNames(e.target.value)} placeholder="p.sh. Ana & Dejan" />
        </label>
        <label>
          Data e dasmës
          <input value={weddingDate} onChange={(e) => setWeddingDate(e.target.value)} placeholder="p.sh. 12 Shtator 2026" />
        </label>
        {savedMsg && <p className="success-msg">{savedMsg}</p>}
        <button type="submit">Ruaj</button>
      </form>

      <form className="settings-card" onSubmit={changePassword}>
        <h3>Ndrysho Fjalëkalimin</h3>
        <label>
          Fjalëkalimi aktual
          <input type="password" value={pwCurrent} onChange={(e) => setPwCurrent(e.target.value)} required />
        </label>
        <label>
          Fjalëkalimi i ri
          <input type="password" value={pwNew} onChange={(e) => setPwNew(e.target.value)} required />
        </label>
        {pwError && <p className="login-error">{pwError}</p>}
        {pwMsg && <p className="success-msg">{pwMsg}</p>}
        <button type="submit">Ndrysho Fjalëkalimin</button>
      </form>
    </div>
  );
}
